module.exports = __webpack_public_path__ + "static/img/bg_footer.628b497.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg_footer.jpg
// module id = r8Zq
// module chunks = 3